var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9256 6.16895C12.8965 6.11765 12.8543 6.07498 12.8034 6.04529C12.7524 6.0156 12.6945 5.99995 12.6356 5.99995H8.2689L9.00098 0.406369C9.00884 0.331508 8.99127 0.256181 8.95111 0.192517C8.91095 0.128853 8.85053 0.0805566 8.77959 0.0554039C8.70864 0.0302511 8.6313 0.0297056 8.56 0.0538553C8.48871 0.0780049 8.42762 0.125444 8.38657 0.188536L3.07623 9.49204C3.04518 9.54254 3.02816 9.60042 3.02693 9.6597C3.0257 9.71898 3.0403 9.77751 3.06923 9.82926C3.09816 9.88101 3.14037 9.92412 3.1915 9.95412C3.24264 9.98412 3.30086 9.99995 3.36015 9.99995H7.66156L7.0814 15.602C7.0757 15.6766 7.09511 15.7509 7.13655 15.8132C7.17799 15.8755 7.23907 15.9222 7.31008 15.9457C7.38108 15.9693 7.45794 15.9685 7.52841 15.9433C7.59888 15.9182 7.65892 15.8702 7.69898 15.807L12.9216 6.50454C12.9519 6.45395 12.9682 6.39624 12.9689 6.33728C12.9696 6.27833 12.9546 6.22024 12.9256 6.16895Z",
    fill: "#FF822D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.e559f87e92d2f9d5e1adc0c6ec4e32dc.svg";
export { ForwardRef as ReactComponent };